
import { mapState } from 'vuex';
import SquareGallery from './components/SquareGallery.vue';

export default {
  i18nComponentKey: 'WidgetReviewsSquareGallery.WidgetReviewsSquareGalleryMobile',
  name: 'WidgetReviewsSquareGalleryMobile',
  components: { SquareGallery },
  computed: {
    ...mapState('widget', ['widget']),
    squareGalleryProps() {
      return this.displayOptions;
    },
    displayOptions() {
      switch (this.widget.posts_per_line) {
        case 2:
          return { cols: 2, gutter: 4, rowGap: 4 };
        case 3:
          return { cols: 3, gutter: 4, rowGap: 4 };
        default:
          return { cols: 1, gutter: 0, rowGap: 4 };
      }
    }
  }
};
